import { Helmet } from 'react-helmet'
import { FtpLogExportButton, FtpLogTable } from 'components/logsFtpCreation'

const FtpCreation = () => {
  return (
    <>
      <Helmet>
        <title>ORMS FTP Creation Logs </title>
      </Helmet>

      <FtpLogExportButton />
      <FtpLogTable />
    </>
  )
}

export default FtpCreation
